import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { installTrustedTypesPolicy } from './app/utils/trusted-types.utils';

// Must run before any Worker is constructed (ZK Phase 9.3 — see trusted-types.utils.ts).
installTrustedTypesPolicy();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
